import { Component, OnInit } from '@angular/core';
import { LangService } from 'src/app/services/lang/lang.service';
import { WinService } from 'src/app/services/win.service';
import { CartService } from 'src/app/services/api/cart.service';
import { ProductService } from 'src/app/services/api/product.service';
import { DebounceService } from 'src/app/services/debounce.service';
import { SessionService } from 'src/app/services/session.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ImageLazyLoad } from "src/app/services/api/files.service";

@Component({
	selector: 'app-cart',
	templateUrl: './cart.component.html',
	styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

	/** use for debounce ethod of updating cart item qty */
	updateCartItem: any = null;

	/** use to ckeck if the user was already login or not */
	timeOutToCheckLogin: any = null;

	/*customPrice: any = null;*/

	/** this tells to show checkout link or not */
	canProceedToCheckOut: boolean = true;

	quickViewImage: string = "";

	constructor(
		public winService: WinService,
		public lang: LangService,
		public cartService: CartService,
		public productService: ProductService,
		public debounce: DebounceService,
		public router: Router,
		public _route: ActivatedRoute,
		public sessionService: SessionService
	) {
		this.updateCartItem = this.debounce.debounce((item) => {
			if (item.cart.qty >= 10) {
				let jsonData = {
				"cartItem": {
					"sku": item.product.sku,
					"qty": item.cart.qty,
					"quote_id": item.cart.quote_id,
					"product_option": item.cart.product_option,
					"extension_attributes": {}
				}
				};
				this.canProceedToCheckOut = false;
				this.cartService.addToCart(jsonData, "PUT", item.cart.item_id).then((cart:any) => {
					if (cart) {
						let c: any = cart;
						
						this.cartService.cartItems.forEach(cItem => {
							if(parseInt(cItem.cart.item_id) == parseInt(item.cart.item_id)){
								cItem.cart.item_id = cart.item_id;
							}
							this.cartService.getItemInfo(cItem);
						});
						this.canProceedToCheckOut = true;
					}
				});
			} else {
				this.canProceedToCheckOut = false;
				this.cartService.toastService.add(this.lang.getLang('l107a'), 'danger', 2000);
			}
		}, 300);
	}

	ngOnInit() {
		this.cartService.cartItems = null;

		if (!this.sessionService.user.isLogedIn) {

			this.timeOutToCheckLogin = setInterval(f => {
				let rUrl = this.router.url.replace('/', '');
				if (rUrl != 'cart') {
					clearInterval(this.timeOutToCheckLogin);
				} else {
					if (this.sessionService.userData) {
						clearInterval(this.timeOutToCheckLogin);
						this.initCart(true);
					} else {
						clearInterval(this.timeOutToCheckLogin);
						let reCallWebapi = setInterval(f => {
							this.cartService.cartItems = [];
							clearInterval(reCallWebapi);
							this.initCart();
						}, 1500);
					}
				}
			}, 1000);
		} else {
			this.cartService.cartItems = null;
			this.cartService.cartItems = [];
			let reCallWebapi = setInterval(f => {
				clearInterval(reCallWebapi);
				this.initCart();
			}, 1500);
		}
	}

	initCart(isSetLoader: boolean = false) {
		if (isSetLoader) {
			this.cartService.setLoader(true);
		}
		this.cartService.cartItems = null;
		this.cartService.getCartId().then(cartId => {
			this.cartService.getCartItems().then(res => {
				let items: any = res;
				if (items.length <= 0) {
					this.cartService.cartItems = [];
				} else {
					this.cartService.cartItems = [];
					items.forEach(item => {
						let cItems = {
							cart: item,
							itemData: {},
							product: {},
							child: {},
							attachment: []
						};

						this.cartService.getItemInfo(cItems);

						let attachUrl = '/rest/entrelable/V1/lns-orderattachment/attachment/' + item.item_id
						this.cartService.get(attachUrl).subscribe(attach => {
							cItems.attachment = attach;
						});

						if(item.sku.match(/custom-t-shirt-/gi)){
							item.sku = 'custom-t-shirt';
						}
						if(item.sku.match(/custom-canvas-tote-bag-/gi)){
							item.sku = 'custom-canvas-tote-bag';
						}

						this.productService.getProductBySku(item.sku).then(childProd => {
							let childProduct: any = childProd;
							cItems.child = childProduct;

							let sku = childProduct.sku;
							sku = sku.replace('-' + childProduct.name, '');
							this.productService.getProductBySku(sku).then(perProd => {
								let product: any = perProd;
								cItems.product = product;

								let custom_options = item.product_option.extension_attributes.custom_options;

								let opts = product.options;

								item['custom_options'] = [];
								custom_options.forEach((option, key) => {
									opts.forEach(opt => {
										if(parseInt(option.option_id) == opt.option_id){
											let co = {
												'title': '',
												'option_value': option.option_value, /** if the value is type of selection this will be change by its title */
												'option_id': option.option_id,
												'option_type_id': option.option_value 
											}

											if(opt.product_sku == 'custom-t-shirt'){ /** for t-shirt */
												co.title = opt.title;
												if(opt.title == 'Color'){
													co.option_value = this.getOptionValueTitle(opt, co);
													co.option_value = co.option_value.split('-');
													co.option_value = co.option_value[0];
													item['custom_options'].push(co);
												}
												else if(opt.title == 'Print Location'){
													co.option_value = this.getOptionValueTitle(opt, co);
													item['custom_options'].push(co);
												}
												else if(this.cartService.inArray(opt.title, ['Size-XS','Size-S','Size-M','Size-L','Size-XL','Size-XXL','Size-XXXL'])){
													if(co.option_value){
														co.title = opt.title.replace('-', ' Qty ');
														item['custom_options'].push(co);
													}
												}
												else if(this.cartService.inArray(opt.title, ['Front Size', 'Back Size', 'Left Arm Size', 'Right Arm Size', 'Inside Tag Size'])){
													co.title = opt.title;
													item['custom_options'].push(co);
												}
											}
											else if(opt.product_sku == 'custom-canvas-tote-bag'){
												co.title = opt.title;
												if(opt.title == 'Sizes' || opt.title == 'Print Location'){
													co.option_value = this.getOptionValueTitle(opt, co);
													item['custom_options'].push(co);
												}
												else if(opt.title == 'Front Print Size' || opt.title == 'Back Print Size'){
													item['custom_options'].push(co);
												}
											}
											else {
												if(opt.title == 'custom size'){
													co.title = 'size';
													co.option_value = co.option_value + ' cm';
													item['custom_options'].push(co);
												}
												else if(opt.title == 'adhesive'){
													co.title = opt.title;
													item['custom_options'].push(co);
												}
												else if(opt.title == 'cutting type'){
													co.title = opt.title;
													opt.values.forEach(optValue => {
														if(co.option_value + '' ==  optValue.option_type_id + '' ){
															co.option_value = optValue.title;
														}
													});
													item['custom_options'].push(co);
												}
											}
										}
									});
								});

								opts.forEach(opt => {
									opt.current_value = '';
									custom_options.forEach((option, key) => {
										if(parseInt(opt.option_id) == parseInt(option.option_id)){
											opt.current_value = option.option_value + "";
										}
									});

									// setTimeout(() => {
										if(opt.title == 'cutting type' && !opt.current_value.length){
											this.canProceedToCheckOut = false;
										}
									// }, 50);
								});

								this.productService.getProductImage(product.id, 150, 150).then(pImage => {
									if (pImage) {
										product['images'] = pImage;
									}
								});
							});
						});

						if (!this.cartService.cartItems) {
							this.cartService.cartItems = [cItems];
						} else {
							this.cartService.cartItems.push(cItems);
						}

						console.log('item item item', cItems);
					});
				}
			});
		});
	}

	getOptionValueTitle(opt:any, co:any){
		let title = [];
		opt.values.forEach(optValue => {
			let coOptionValues = co.option_value.split(',');
			coOptionValues.forEach(coOptionValue => {
				if(coOptionValue + '' ==  optValue.option_type_id + '' ){
					title.push(optValue.title);
				}
			});
		});
		return title.join(', ');
	}

	/**
	 * update the qty of the item if the button is click
	 */
	editQty(item, action: string = "") {
		item.cart.qty = '' + item.cart.qty;

		if (item.cart.qty.length) {
			let cartQty = parseInt(item.cart.qty);
			if (action.length) {
				let interval = '100';
				if(item.product.sku == 'custom-canvas-tote-bag'){
					interval = '1';
				}
				let expression = cartQty + " " + action + ' ' + interval;
				cartQty = parseInt(eval(expression));

				item.cart.qty = cartQty;
				if (cartQty < 10) {
					item.cart.qty = 10;
				}
			} else {
				item.cart.qty = parseInt(item.cart.qty);
			}
		}
		this.updateCartItem(item);
	}

	/**
	 * because ngStyle only fire upon init
	 * we  have to use this to get the class for an element need to
	 * have flex ai-center
	 */
  get flexForLargeScreen() {
    if (window.outerWidth >= 768) {
      return 'flex ai-center';
    } else {
      return '';
    }
  }

	/**
	 * return false is the user type any char other than int
	 */
  isNumberKey(evt: any) {
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    if (
      charCode == 8 ||
      charCode == 110 ||
      charCode == 190 ||
      (charCode >= 96 && charCode <= 105) ||
      (charCode >= 48 && charCode <= 57) ||
      (charCode >= 37 && charCode <= 40)
    ) {
      return true;
    } else {
      return false;
    }
  }

	/**
	 * return the computation of the total amount of the items
	 */
  get subTotal() {
    let total = 0;
    let currency = '';
    if (this.cartService.cart) {
      currency = this.cartService.cart.currency.store_currency_code + " ";
    }

    if (this.cartService.cartItems) {
      this.cartService.cartItems.forEach(val => {
        if (val.itemData.discounted_total) {
          total += val.itemData.discounted_total;
        }
      });
    }
    return total + '';
  }

	/**
	 * delete an item from the cart
	 */
  deleteItem(item) {
    this.cartService.setLoader(true);

    if (this.sessionService.user.isLogedIn) {
      let url = '/rest/entrelable/V1/carts/mine/items/' + item.cart.item_id;
      this.cartService.makeRequest(url, null, 'DELETE').then(res => {
        if (res) {
          this.deleteItemHelper(item);
        }
        this.cartService.setLoader(false);
      });
    } else {
      let url = '/rest/entrelable/V1/guest-carts/' + this.cartService.guestCartId + '/items/' + item.cart.item_id;
      this.cartService.del(url).subscribe(deletedItem => {
        if (deletedItem) {
          this.deleteItemHelper(item);
        }
        this.cartService.setLoader(false);
      });
    }
  }

  deleteItemHelper(item) {
    this.cartService.cartItems.forEach((val, key) => {
      if (val.cart.item_id == item.cart.item_id) {
        this.cartService.cartItems.splice(key, 1);
      }
    });
    this.cartService.getCart().then(cart => {
      this.cartService.cartItems.forEach(cItem => {
        this.cartService.getItemInfo(cItem);
      });
    });
  }

  	async updateProductOption(e, item, option){
		if(!e.target.value.length){
			this.cartService.toastService.add('Please select a valid cutting type', 'danger');
		}
		else {
			let co = item.cart.product_option.extension_attributes.custom_options;
	
			function getIndexByOptionId(optionId:number):Promise<string>{
				return new Promise(resolve => {
					let i:string = '';
					let loopCount = 0;
					co.forEach((custom_option, key) => {
						if(custom_option.option_id == optionId){
							i = key + '';
						}
	
						loopCount++;
					});
					
					let checker = setInterval(() => {
						if(loopCount == co.length){
							resolve(i);
							clearInterval(checker);
						}
					}, 5);
				});
			}
	
			let i:string = await getIndexByOptionId(option.option_id);
	
			/** 
			 * this means that the item has an specific option option 
			 */
			if(i.length){ 
				co[i].option_value = e.target.value;
			}
			else {
				co.push({
					option_id: "" + option.option_id,
					option_value: "" + e.target.value,
				});
			}
	
			// item.cart.product_option.extension_attributes.custom_options.forEach(custom_option => {
			// 	if(custom_option.option_id == option.option_id){
			// 		custom_option.option_value = e.target.value;
			// 	}
			// });
			setTimeout(() => {
				this.updateCartItem(item);
			}, 100);
		}
	}

	openQuickViewArtWorkModal(attachment: any, isAdminAttach=false){

		let filename = attachment.others.filename;
		let isImage = /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(filename);
		if(isAdminAttach){
			isImage = true;
		}

		if(isAdminAttach){
			if(typeof attachment.others.admin_attachment != "undefined"){
				this.quickViewImage = attachment.others.admin_attachment.firesotre_link + "";
			}
		}
		else if(isImage) {
			this.quickViewImage = attachment.google_firestore_link + "";
		}
		if(isImage) {
			let closeLayoutView = (event) => {
				if (event.key === 'Escape') {
					this.quickViewImage = "";
					document.removeEventListener('keydown', closeLayoutView);
				}
			}

			document.addEventListener('keydown', closeLayoutView);

			setTimeout(() => {
				let imageLazyLoad = new ImageLazyLoad();
				imageLazyLoad.init('qva-image-view', 'w-50', 'qva-image-view-loaded', () => {
					if(isAdminAttach){
						attachment.others.admin_attachment.is_loaded = true;
					}
					else {
						attachment.is_loaded = true;
					}
				});
			}, 10);
		}
		else {
			// this.downloadFile(attachment.others.downloadUrl, attachment.others.filename);
		}
	}
}
